import React, { useState, useEffect } from "react";
import { Row, Col, Card, Input, Divider, Button, Select } from "antd";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { CatalogAction } from "../../store/actions";
import { useHistory } from "react-router-dom";

const { Option } = Select;
const CardWrapper = styled(Card)`
  min-height: 400px;
`;

const arr = [];
const { TextArea } = Input;
function Category_Info({ location }) {
  const dispatch = useDispatch();


  useEffect(() => {
    console.log('locationState==>', location?.state)
    if (location?.state) {
      dispatch(CatalogAction.getTabProductKeyReq(location?.state?.activeKey))

    }
  }, [])

  const [productId, setProductId] = useState(location?.state?.id);
  let [isOpenModal, setIsOpenModal] = useState(false);
  let [isAdditiveModal, setIsAdditiveModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const categories = useSelector((store) => store?.CatalogReducer?.categories);

  const history = useHistory();

  // const getBasemixCategories = (params) =>
  //   dispatch(CatalogAction.getBasemixCategoriesReq(params));
  const postBasemixesCategories = (payload, cb) =>
    dispatch(CatalogAction.postBasemixCategoriesReq(payload, cb));
  const postBasemixesReq = (payload, cb) =>
    dispatch(CatalogAction.postBasemixesReq(payload, cb));

  // const basemixData = useSelector(
  //   (store) => store?.CatalogReducer?.basemixData
  // );
  // const additivesData = useSelector(
  //   (store) => store?.CatalogReducer?.additives
  // );
  // const dataInBasemix = useSelector(
  //   (store) => store?.CatalogReducer?.basemixes
  // );

  const [category, setCategory] = useState([]);
  const [basemix, setBasemix] = useState([]);
  const [additives, setAdditives] = useState([]);
  const [basemixDeatil, setBasemixDetail] = useState({});

  const [customProduct, setCustomProduct] = useState(
    { ...location?.state } || {
      name: "",
    }
  );

  const [customError, setCustomError] = useState({
    nameError: "",
    basemix_category_idError: "",
    basemix_idError: "",
  });

  const postCustomProductData = (customProduct) => {
    const err = { ...customError };
    console.log("Custom Prodcut===>", customProduct);

    if (!customProduct?.name?.trim()?.length) {
      if (!customProduct?.name?.trim()?.length) {
        err.nameError = "Category name is required";
      }
      setCustomError(err);
      return;
    }
    if (location?.state?.id) {
      const { alias, description, name } = customProduct;
      dispatch(
        CatalogAction.updateCategoryCatalogReq(
          {
            alias,
            description,
            name,
          },
          productId,
          () => history.push("/product")
        )
      );
    } else {
      dispatch(
        CatalogAction.postCategoryCatalogReq(customProduct, () =>
          history.push("/product")
        )
      );
    }
  };

  return (
    <CardWrapper style={{ marginTop: "10px" }}>
      <Row gutter={[0, 10]}>
        <Col
          span={24}
          className="st-table-header"
          style={{ marginBottom: "10px" }}
        >
          <h5
            className="text-left general-text-heading  "
            style={{
              fontSize: "20px",
              color: "#323761",
            }}
          >
            {!location?.state?.id ? "New Category" : " Update Category"}
          </h5>
        </Col>
        <Col xl={6} lg={12} md={24} sm={24} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} lg={24} xs={11} sm={11} md={24} className="text-left">
              <label style={{ fontSize: "12px" }}>
                Category Name
                <span style={{ color: "orange", fontSize: "10px" }}>*</span>
              </label>
            </Col>
            <Col xl={23} lg={12} md={24} sm={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    name: e.target.value,
                  });
                  setCustomError({
                    ...customError,
                    nameError: "",
                  });
                }}
                value={customProduct?.name}
              />
              <Row justify="start">
                <Col>
                  <span className="danger-color text-left">
                    {customError.nameError && customError.nameError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xl={6} lg={4} md={24} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} lg={12} xs={9} sm={9} md={4} className="text-left">
              <label style={{ fontSize: "12px" }}>Category Alias</label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    alias: e.target.value,
                  });
                }}
                value={customProduct?.alias}
              />
            </Col>
          </Row>
        </Col>

        <Col xl={24} sm={12} md={6} lg={12} className="text-left">
          <Row justify="start">
            <Col xl={12} xs={24} md={24}>
              <label style={{ fontSize: "12px" }}>Category Description</label>
              <TextArea
                autoSize={{ minRows: 3, maxRows: 5 }}
                onChange={(e) =>
                  setCustomProduct({
                    ...customProduct,
                    description: e.target.value,
                  })
                }
                value={customProduct?.description}
              />
            </Col>
          </Row>
        </Col>
        <Col xl={12}>
          <Row justify="end">
            <Col xl={6} lg={6} md={6} xs={24} sm={24}>
              <Button
                style={{
                  backgroundColor: "#f57c00",
                  color: "#fff",
                  letterSpacing: ".5px",
                  transition: ".2s ease-out(red)",
                  fontSize: "12px",
                }}
                block
                onClick={() => postCustomProductData(customProduct)}
              >
                SAVE
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </CardWrapper>
  );
}
export default Category_Info;
